import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'
import { AuthProvider } from './providers/AuthProvider.tsx'
import { TenantAppProvider } from './providers/TenantAppProvider.tsx'
import { AppProvider } from './providers/AppProvider.tsx'
import { ThemeProvider } from './providers/ThemeProvider.tsx'
import { NotificationProvider } from './providers/NotificationProvider.tsx'
import { PwaUpdatePrompt } from './pwa/PwaUpdatePrompt.tsx'

if (import.meta.env.DEV) {
  import('eruda').then((eruda) => {
    const e = eruda.default;
    e.init({
      defaults: {
        displaySize: 20,
        theme: 'Dark',
      }
    });
    e.position({
      x: 10,
      y: window.innerHeight - 60
    });
  }).catch((err) => {
    console.error('Errore nel caricamento di Eruda:', err);
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <NotificationProvider>
      <PwaUpdatePrompt />
      <AuthProvider>
        <TenantAppProvider>
          <ThemeProvider>
            <AppProvider>
              <App />
            </AppProvider>
          </ThemeProvider>
        </TenantAppProvider>
      </AuthProvider>
    </NotificationProvider>
  </StrictMode>,
)
